export default __webpack_public_path__ + "static/Polygon_blockchain_logo_dark-55f27b6305584fa5f049dd039a9d7d21.png";